import React from 'react';
import { Completeness } from '../../utils/completeness';
import { useLanguage } from '../../contexts/LanguageContext';

interface CompletenessPanelProps {
  completeness: Completeness;
  onEdit: () => void;
}

const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" aria-hidden>
    <path d="M5 12.5l4.5 4.5L19 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * Чек-лист заполнения карточки.
 *
 * Считается на фронте из уже загруженного профиля — см. utils/completeness.
 * Обязательные пункты (без них заведение не активируется) идут первыми и
 * отмечены отдельно: остальное влияет на то, как карточка выглядит, но
 * не на запуск.
 */
export const CompletenessPanel: React.FC<CompletenessPanelProps> = ({ completeness, onEdit }) => {
  const { t } = useLanguage();

  return (
    <section className="qp-panel">
      <header className="qp-panel-head">
        <h2 className="qp-label">{t.cabinet.cardFilledPercent} {completeness.percent}%</h2>
        <button type="button" className="qp-link" onClick={onEdit}>
          {t.cabinet.fillAction}
        </button>
      </header>

      <div className="qp-meter" style={{ width: '100%', marginBottom: 16 }}>
        <span style={{ width: `${completeness.percent}%` }} />
      </div>

      <div className="qp-check">
        {completeness.items.map((item) => (
          <div
            key={item.key}
            className={`qp-check-row ${item.done ? 'qp-check-row--done' : 'qp-check-row--todo'}`}
          >
            <span className="qp-check-box">{item.done ? <IconCheck /> : null}</span>
            <span className="qp-check-label">
              {item.label}
              {item.required && !item.done && (
                <span className="qp-faint qp-mono" style={{ fontSize: 10, marginLeft: 6 }}>
                  {t.cabinet.requiredTag}
                </span>
              )}
            </span>
            <span className="qp-check-hint">{item.hint}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
